import React, { useEffect, useState } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const Sidebar = ({ isVisible, uploadMenuClick, homeMenuClick, searchMenuClick }) => {

  return (
    <div className={`sidebar ${isVisible ? 'visible' : ''}`} style={{paddingTop:'5px'}}>
      <div className="verticalNav">
        <a onClick={homeMenuClick} ><HomeIcon style={{marginRight:'10px'}} />Home</a>
        <a onClick={uploadMenuClick}><FileUploadIcon style={{marginRight:'10px'}} />Upload</a>
        <a onClick={searchMenuClick}><ManageSearchIcon  style={{marginRight:'10px'}}/>Notice List</a>        
      </div>
    </div >
  );
};

export default Sidebar;
